<template>
  <div class="modalbox-content">
    <div class="variacoes__hint">
      <CIcon name="cil-info" size="sm" />
      <span>
        Estes campos são usados como <strong>variações de SKU</strong> nos grupos de grade
        (ex: cor, tamanho, voltagem, sabor). O <strong>significado</strong> de cada variação
        é definido por grupo de grade (em "Cadastros → Grupos de Grade"), permitindo que
        a mesma coluna represente conceitos diferentes em categorias diferentes — voltagem
        em elétricos, cor em vestimentas, etc.
      </span>
    </div>

    <div class="section-label">Valores das variações</div>
    <v-row>
      <v-col v-for="numero in 10" :key="numero" cols="6">
        <div class="form-group">
          <label class="field-label">
            Variação {{ numero }}
            <BadgeErp :campo="`variacao${numero}`" :camposSincronizados="camposSincronizados" />
          </label>
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="item[`variacao${numero}`]"
            maxlength="50"
            placeholder="ex: VERMELHO, 110V, P"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BadgeErp from "@/components/BadgeErp";

export default {
  name: "Variacoes",
  components: { BadgeErp },
  props: {
    item: { type: Object, required: true },
    camposSincronizados: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.variacoes__hint {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px 14px;
  background: #edf8f9;
  border: 1px solid #c5e6e9;
  border-radius: 8px;
  font-size: 13px;
  color: #1a7a83;
  line-height: 1.5;
  margin-bottom: 14px;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 8px;
}

.form-group {
  margin-bottom: 12px;
}
</style>
